import * as JSZip from 'jszip';
import { KostDataImportDatasetInputProcessorProgressEvent } from '@bindoc-projects/kost-data-import-domain-lib';
import {
  KOST_FILE_NAME_REG_EXP,
  KOST_FILE_NAMES,
  KOST_FILES_REQUIRED,
  KostFileNames,
} from './de-kost-file.const';

export class KostFileExtractor {
  public static async extract(
    files: {
      [fileType in KostFileNames]: JSZip.JSZipObject;
    },
    progressCallback: (
      event: KostDataImportDatasetInputProcessorProgressEvent,
    ) => void,
  ): Promise<{
    files: {
      [fileType in KostFileNames]: string;
    };
    errors: string[];
  }> {
    progressCallback({ step: 'FILE_EXTRACTING', current: 0, max: 1 });
    const reqs = KOST_FILE_NAMES.map((fileName) =>
      KostFileExtractor._extractFile(fileName, files, progressCallback),
    );

    return await Promise.all(reqs).then((fileContents) => {
      const errors = fileContents.flatMap((result) =>
        result.error ? [result.error] : [],
      );
      const files = Object.fromEntries(
        KOST_FILE_NAMES.map((name, index) => [
          name,
          fileContents.at(index).file || null,
        ]),
      ) as Record<KostFileNames, string>;
      const result = { files, errors };

      progressCallback({ step: 'FILE_EXTRACTING', current: 1, max: 1 });

      return result;
    });
  }

  private static async _extractFile(
    fileNameToExtract: KostFileNames,
    files: { [key: string]: JSZip.JSZipObject },
    progressCallback: (
      event: KostDataImportDatasetInputProcessorProgressEvent,
    ) => void,
  ): Promise<{ file?: string; error?: string }> {
    const result: { file?: string; error?: string } = {};
    const regex = new Map(Object.entries(KOST_FILE_NAME_REG_EXP)).get(
      fileNameToExtract,
    );
    const required = new Map(Object.entries(KOST_FILES_REQUIRED)).get(
      fileNameToExtract,
    );
    const matchingFiles = Object.entries(files).filter(([name]) =>
      regex.test(name.toUpperCase()),
    );

    if (matchingFiles.length === 0 && required) {
      result.error = `Datei nicht gefunden: ${fileNameToExtract}.CSV`;
    } else if (matchingFiles.length > 0) {
      const [fileName, file] = matchingFiles[0];
      progressCallback({
        step: `Datei ${fileName} für ${fileNameToExtract}.CSV erkannt`,
        current: 0,
        max: 1,
        type: { name$: 'STEP_UPDATE' },
      });
      result.file = await file.async('binarystring');
    }
    return result;
  }
}
